// extracted by mini-css-extract-plugin
module.exports = {"firstRowWithControls":"_38WenpBn6jvKUa-jk6duAH","secondRowWithControls":"_1c1Tmcun7fh1mefUM5MYb5"};